export default class HashManager {
    constructor(parent) {
        this.parent = parent;
        this.params = new URLSearchParams(window.location.hash.split('?')[1] || '');
    }

    update() {
        window.location.hash = this.params.toString();
    }

    get(key) {
        return this.params.get(key);
    }

    set(key, value) {
        this.params.set(key, value);
    }

    has(key) {
        return this.params.has(key);
    }

    remove(key) {
        this.params.delete(key);
    }
}
